<template>
  <Teleport to="body">
  <Transition name="customer-group-modal-overlay">
    <div
      v-if="visible"
      class="customer-group-modal-overlay customer-group-modal-overlay--glass"
      @click.self="$emit('cancel')"
    >
      <Transition name="customer-group-modal-panel" appear>
        <div
          v-if="visible"
          class="customer-group-modal-card customer-group-modal-card--glass"
          role="dialog"
          aria-modal="true"
          aria-labelledby="customer-group-modal-title"
          @click.stop
        >
          <div class="customer-group-modal-header customer-group-modal-header--glass">
            <h2 id="customer-group-modal-title" class="customer-group-modal-title">
              Customer Group
            </h2>
            <button
              type="button"
              class="customer-group-modal-close-btn"
              aria-label="Close"
              title="Close"
              @click="$emit('cancel')"
            >
              <i class="bi bi-x-lg" aria-hidden="true"></i>
            </button>
          </div>

          <div class="customer-group-modal-body customer-group-modal-body--glass">
            <LabelInputField
              input-id="customer-group-name"
              label="Name"
              v-model="groupName"
              placeholder="e.g. Wholesale"
              required
              flex
              :has-error="!!error"
              :disabled="saving"
              @input="error = ''"
            >
              <div v-if="error" class="customer-group-modal-error">{{ error }}</div>
            </LabelInputField>
          </div>

          <div class="customer-group-modal-actions customer-group-modal-actions--glass">
            <SecondaryButton label="Cancel" :disabled="saving" @click="$emit('cancel')" />
            <PrimaryButton label="Save" :loading="saving" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>

  <ErrorModal
    :show="showErrorModal"
    title="Validation Error"
    :message="errorMessage"
    buttonText="OK"
    @close="closeErrorModal"
  />
  </Teleport>
</template>

<script>
import '../styles/AddNewCustomerGroup.css';
import CompanyService from '@/services/company.service.js';
import ErrorModal from '@/components/ErrorModal.vue';
import LabelInputField from '@/modules/consultant/components/LabelInputField.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'AddNewCustomerGroup',
  components: {
    ErrorModal,
    LabelInputField,
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      groupName: '',
      error: '',
      saving: false,
      showErrorModal: false,
      errorMessage: '',
    };
  },
  methods: {
    async ok() {
      if (!this.groupName.trim()) {
        this.error = 'Name field is required.';
        return;
      }
      this.saving = true;
      this.error = '';
      try {
        const group = await CompanyService.createCustomerGroup({
          name: this.groupName.trim(),
          companyId: this.companyId,
        });
        this.$emit('ok', group);
        this.groupName = '';
        this.error = '';
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message || err.message || 'Failed to create customer group.';
        this.showErrorModal = true;
      } finally {
        this.saving = false;
      }
    },

    closeErrorModal() {
      this.showErrorModal = false;
      this.errorMessage = '';
    },
  },
};
</script>
